(() => {
  const root = document.querySelector('[data-japan-v2-product]');
  if (!root) return;
  document.body.classList.add('has-japan-pdp-v2');
  const catalog = JSON.parse(document.getElementById('japan-996-catalog').textContent).colors;
  const state = JSON.parse(document.getElementById('japan-996-state').textContent);
  const size = root.querySelector('[data-v2-size]');
  const form = root.querySelector('[data-v2-form]');
  const buy = root.querySelector('[data-v2-buy]');
  const actions = [buy];
  const variantId = root.querySelector('[data-variant-id]');
  const status = root.querySelector('[data-v2-status]');
  const main = root.querySelector('[data-v2-main]');
  const thumbnails = root.querySelector('[data-v2-thumbnails]');
  const count = root.querySelector('[data-image-count]');
  const sticky = document.querySelector('[data-v2-sticky]');
  const lightbox = document.querySelector('[data-v2-lightbox]');
  const purchaseEnabled = state.enabled && Boolean(state.productUrl);
  let color = catalog[0];
  let imageIndex = 0;
  let request = null;
  let revision = 0;
  let loading = false;
  let resolved = null;
  let submitting = false;
  const money = cents => new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY',maximumFractionDigits:0}).format(cents/100);
  const renderPrice = variant => {
    const price = Number(variant.price);
    const compare = Number(variant.compare_at_price);
    const onSale = compare > price && price >= 0;
    root.querySelector('[data-v2-price]').textContent = money(price);
    const comparison = root.querySelector('[data-v2-compare]');
    const badge = root.querySelector('[data-v2-sale]');
    comparison.hidden = !onSale; comparison.textContent = onSale ? money(compare) : '';
    badge.hidden = !onSale; badge.textContent = onSale ? `${Math.round((compare-price)/compare*100)}% OFF` : '';
    sticky.querySelector('.pdp-sticky-price').textContent = money(price);
  };
  const setActions = (disabled, busy = false) => actions.forEach(button => {
    button.disabled = disabled;
    if (busy) button.setAttribute('aria-busy','true'); else button.removeAttribute('aria-busy');
  });
  const setImage = index => {
    imageIndex = (index + color.gallery.length) % color.gallery.length;
    main.src = color.gallery[imageIndex];
    main.alt = `New Balance 996 ${color.name}・商品画像${imageIndex + 1}`;
    count.textContent = `${imageIndex + 1} / ${color.gallery.length}`;
    thumbnails.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===imageIndex)));
    root.querySelectorAll('[data-gallery-step]').forEach(button=>button.disabled=color.gallery.length<2);
  };
  const rebuildGallery = () => {
    thumbnails.replaceChildren(...color.gallery.map((url,index)=>{
      const button=document.createElement('button');button.type='button';button.dataset.galleryIndex=String(index);button.setAttribute('aria-label',`${color.name}の商品画像 ${index+1}`);
      const image=document.createElement('img');image.src=url;image.alt='';image.width=90;image.height=70;image.loading='lazy';button.append(image);return button;
    }));
    setImage(0);
  };
  const syncSticky = () => {
    sticky.querySelector('[data-sticky-image]').src=color.image;
    sticky.querySelector('[data-sticky-label]').textContent=color.name+(size.value?' / '+size.value:'');
  };
  const resolveVariant = async () => {
    revision += 1;
    const current = revision;
    request?.abort();request=null;resolved=null;variantId.value='';loading=false;status.textContent='';
    setActions(submitting);
    syncSticky();
    if (!state.productUrl || !size.value) return;
    const colorValue=state.options.find(option=>option.name==='カラー')?.values.find(value=>value.name===color.name);
    const sizeValue=state.options.find(option=>option.name==='サイズ')?.values.find(value=>value.name===size.value);
    if(!colorValue || !sizeValue){status.textContent='この組み合わせを確認できませんでした。別のサイズをお選びください。';setActions(purchaseEnabled);return;}
    request=new AbortController();loading=true;setActions(true,true);
    try {
      // Section rendering resolves one exact combination, including products with more than 250 variants.
      const url=new URL(state.productUrl,location.origin);url.searchParams.set('option_values',`${colorValue.id},${sizeValue.id}`);url.searchParams.set('section_id',state.sectionId);
      const response=await fetch(url,{signal:request.signal,credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('variant-response');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const payload=doc.getElementById('japan-996-state');if(!payload)throw new Error('variant-state');
      const variant=JSON.parse(payload.textContent).selected;
      if(current!==revision)return;
      if(!variant || variant.option1!==color.name || variant.option2!==size.value){status.textContent='このカラー・サイズは現在お選びいただけません。別の組み合わせをお試しください。';return;}
      renderPrice(variant);
      if(!variant.available){status.textContent='このカラー・サイズは現在お選びいただけません。別の組み合わせをお試しください。';return;}
      resolved=variant;variantId.value=String(variant.id);
    } catch(error) {
      if(error.name!=='AbortError' && current===revision)status.textContent='選択内容を確認できませんでした。もう一度サイズをお選びください。';
    } finally {
      if(current===revision){loading=false;setActions(submitting || (purchaseEnabled && !resolved));}
    }
  };
  const chooseColor = code => {
    if(submitting)return;
    const next=catalog.find(entry=>entry.code===code);if(!next)return;
    color=next;root.querySelector('[data-color-name]').textContent=color.name;root.querySelector('[data-spec-color]').textContent=color.name;
    root.querySelector('[data-color-summary-name]').textContent=color.name;
    root.querySelector('[data-color-summary-image]').src=color.image;
    root.querySelector('[data-color-selector]').open=false;
    root.querySelector('.pdp-color-toggle').textContent='全25色を見る';
    renderPrice(state.initialPrice);
    root.querySelectorAll('input[name="color-choice"]').forEach(input=>input.checked=input.value===code);
    rebuildGallery();resolveVariant();
  };
  root.querySelectorAll('input[name="color-choice"]').forEach(input=>input.addEventListener('change',()=>chooseColor(input.value)));
  thumbnails.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-index]');if(button)setImage(Number(button.dataset.galleryIndex));});
  root.querySelectorAll('[data-gallery-step]').forEach(button=>button.addEventListener('click',()=>setImage(imageIndex+Number(button.dataset.galleryStep))));
  size.addEventListener('change',resolveVariant);
  root.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{const quantity=form.elements.quantity;quantity.value=String(Math.min(10,Math.max(1,(Number(quantity.value)||1)+Number(button.dataset.quantityStep))));}));
  const attemptPurchase = async event => {
    event.preventDefault();
    if(submitting)return;
    if(!size.value){size.focus();status.textContent='サイズを選択してください。';return;}
    if(!form.reportValidity())return;
    if(!purchaseEnabled){status.textContent=`${color.name} / ${size.value}を選択しました。現在は販売開始の準備中です。`;return;}
    if(loading || !resolved || !variantId.value){status.textContent='選択内容を確認中です。しばらくしてからもう一度お試しください。';return;}
    const checkout = !event.submitter || event.submitter === buy;
    submitting=true;setActions(true,true);
    // Freeze the selected options until this single add request finishes.
    const controls = [...root.querySelectorAll('input,select,button[data-quantity-step]')];
    controls.forEach(control=>control.disabled=true);
    status.textContent=checkout?'購入手続きへ進んでいます…':'カートに追加しています…';
    let added = false;
    try {
      const response=await fetch(`${form.action}.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId.value),quantity:Number(form.elements.quantity.value)}]})});
      if(!response.ok){status.textContent=response.status===422?'この数量をカートに追加できませんでした。数量やサイズを変更してお試しください。':'カートに追加できませんでした。時間をおいてお試しください。';return;}
      added = true;
      if(checkout){
        // A real link click lets the installed checkout integration intercept this route.
        const link=document.createElement('a');link.href=state.checkoutUrl;link.hidden=true;
        document.body.append(link);link.click();link.remove();
      }else location.assign(state.cartUrl);
    } catch(error) {
      status.textContent='通信を確認できませんでした。再操作する前にカートをご確認ください。';
    } finally {
      if(!added){submitting=false;controls.forEach(control=>control.disabled=false);setActions(false);}
    }
  };
  form.addEventListener('submit',attemptPurchase);
  root.querySelector('[data-color-selector]').addEventListener('toggle',event=>{root.querySelector('.pdp-color-toggle').textContent=event.target.open?'閉じる':'全25色を見る';});
  const chooseSection=()=>{root.querySelector('.pdp-buying').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});};
  document.querySelectorAll('[data-color-jump]').forEach(button=>button.addEventListener('click',()=>{chooseColor(button.dataset.colorJump);chooseSection();}));
  document.querySelector('[data-sticky-choose]').addEventListener('click',chooseSection);
  const observer=new IntersectionObserver(()=>{sticky.hidden=buy.getBoundingClientRect().bottom>0;},{threshold:[0,1]});observer.observe(buy);
  root.querySelector('[data-zoom]').addEventListener('click',()=>{const image=lightbox.querySelector('img');image.src=main.src;image.alt=main.alt;lightbox.showModal();});
  lightbox.querySelector('[data-close-lightbox]').addEventListener('click',()=>lightbox.close());
  lightbox.addEventListener('click',event=>{if(event.target===lightbox)lightbox.close();});
  if(state.selected){const selectedColor=catalog.find(entry=>entry.name===state.selected.option1);if(selectedColor){color=selectedColor;size.value=state.selected.option2;chooseColor(color.code);}}
  renderPrice(state.initialPrice);syncSticky();
})();
